import { useQuery } from '@tanstack/react-query';
import type { Server } from '../api/types.js';
import { useApiClient } from './use-api-client.js';

function hasTransitioning(servers: Server[] | undefined): boolean {
  if (!servers) return false;
  return servers.some((s) => s.status === 'starting' || s.status === 'stopping');
}

export function useServers() {
  const api = useApiClient();

  const query = useQuery({
    queryKey: ['servers'],
    queryFn: () => api.servers.list(),
    refetchInterval: (query) =>
      hasTransitioning(query.state.data) ? 5_000 : 30_000,
  });

  return query;
}

export function useServer(serverId: string) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['server', serverId],
    queryFn: () => api.servers.get(serverId),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'starting' || status === 'stopping') return 5_000;
      return 30_000;
    },
  });
}
